export default class Header {
    constructor() {
        this.myAnimation = null;
        this.init();
        this.initEventsListener();
    }

    init() {
    }

    initEventsListener() {
        $('.burger-menu__button').off('click').on('click', (e) => {
            let $body = $('body');

            $body.toggleClass('menu-open');
            let $layoutContent = $('#layout-content');
            if ($body.hasClass('menu-open')) {
                $('#burger-header').removeClass('invisible');
                $('#header-image-right').removeClass('invisible');

                let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

                /* window.onscroll = function () {
                    window.scrollTo(scrollLeft, scrollTop);
                }; */
            } else {
                /* window.onscroll = function () {
                    window.scrollTo();
                }; */
                setTimeout(() => {
                    $('#burger-header').addClass('invisible');
                    $('#header-image-right').addClass('invisible');
                }, 1000);
            }

        });


        $('.burger-menu__content__items__item[data-sub="true"]').on('click', (e) => {
            let $element = $(e.currentTarget);

            if (!$element.hasClass('burger-menu__content__items__item__subs') && $element.hasClass('active')) return true;

            $('.burger-menu__content__items__item[data-sub="true"]').removeClass('active');
            $('.burger-menu__content__items__item__subs').slideUp();

            $element.addClass('active');
            $element.find('.burger-menu__content__items__item__subs').slideDown();
        });


        $('.burger-menu__content__items__item').on('mouseleave', (e) => {
            $('.header-image-right_image').removeClass('show');
        });

        $('.burger-menu__content__items__item').on('mouseenter', (e) => {
            let $element = $(e.currentTarget);

            let image = $element.data('image');

            if (image !== undefined) {
                $('.header-image-right_image[data-image="' + image + '"]').addClass('show');
            }
        });

        $('.burger-menu__right_search').off('click').on('click', (e) => {
            $(e.currentTarget).siblings('.input-search').addClass('show');
        });
    }
}
